module.exports = __webpack_public_path__ + "/images/mockup-llista-it-no-fondo.6b5edd1.png";